import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FieldWrapper } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { VariableService } from './../../../../services/utilities/variables.service';
import { FormFieldWrapperService } from '../../../../services/utilities/form-field-wrapper.service';
import { Colors, Icons } from '../../../../utilities/enum';
import { CdmService } from '../../../../services/application/cdm.service';
import { tenant } from '../../../../../tenants/tenant';

@Component({
    selector: 'app-form-field-wrapper',
    templateUrl: './form-field-wrapper.component.html',
    styleUrls: ['./form-field-wrapper.component.scss'],
    standalone: false
})
export class FormFieldWrapperComponent extends FieldWrapper implements OnInit, OnDestroy {

    private subscription = new Subscription();
    private subscriptionHiddenFields = new Subscription();

    error: any; // TODO: add type
    icons = Icons;
    colors = Colors;
    showErrorOnLoad = true;
    displayText = '';
    hidden = false;

    constructor(
        private customerService: FormFieldWrapperService,
        private _cdmService: CdmService,
        private _router: Router,
        private _variableService: VariableService
    ) {
        super();
    }

    ngOnInit(): void {
        const LOOKUP_VALUE = this.field['displayValue'] !== undefined ? this.field['displayValue'] : this.to.label ? this.to.label : this.field['key'];
        const _titleReplacement = this._variableService.axDisplayTextLookUpData.find(x => x.key.toLowerCase() === LOOKUP_VALUE.toLowerCase());
        if (_titleReplacement && _titleReplacement.value !== '') {
            this.displayText = _titleReplacement.value;
        } else {
            this.displayText = LOOKUP_VALUE;
        }

        this.subscription.add(this.customerService.alerts$.subscribe((data) => {
            this.error = data?.find(i => i.property === this.key && i.id === this?.field?.model?.Id);
        }));

        if (this._router.url.split('/')[1].toLowerCase() === 'overview' && tenant.disableFormlyValidation) {
            this.showErrorOnLoad = false;
        } else {
            this.showErrorOnLoad = true;
        }

        this.subscriptionHiddenFields.add(this._cdmService.hiddenFields.subscribe((fields) => {
            this.field.hide = this._cdmService.hideFields(fields, this.field);
        })
        );
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        this.subscriptionHiddenFields?.unsubscribe();
    }

}
